import type { ReactNode } from 'react';

import styles from './FactList.module.css';

export interface Fact {
  label: string;
  value: ReactNode;
  /** Draw the value in monospace, for ids a reader may copy. */
  code?: boolean;
}

export interface FactListProps {
  label: string;
  facts: readonly Fact[];
}

/** A record's fields as label/value pairs; an empty value reads as a dash. */
export function FactList({ label, facts }: FactListProps) {
  return (
    <dl aria-label={label} className={styles.list}>
      {facts.map((fact) => (
        <div className={styles.row} key={fact.label}>
          <dt className={styles.label}>{fact.label}</dt>
          <dd className={fact.code ? `${styles.value} ${styles.code}` : styles.value}>
            {fact.value === null || fact.value === undefined || fact.value === ''
              ? '—'
              : fact.value}
          </dd>
        </div>
      ))}
    </dl>
  );
}
